import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import EventCard from "@/components/feature/EventCard";
import { liveEvents } from "@/mocks/events";

export default function LiveNowSection() {
  return (
    <section className="border-y border-background-200 bg-background-100/60">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="Live Now"
          title="正在进行中的赛事"
          description="实时比分同步更新，点击卡片即可进入直播间观看。"
          action={
            <Link
              to="/schedule"
              className="inline-flex items-center gap-1.5 rounded-md border border-background-300 bg-background-50 px-4 py-2.5 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-500/50 hover:text-primary-400 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-calendar-schedule-line" />
              全部赛程
            </Link>
          }
        />
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {liveEvents.map((event) => (
            <EventCard key={event.id} event={event} />
          ))}
        </div>
      </div>
    </section>
  );
}